import React, { FunctionComponent } from 'react'

import { useTranslation } from 'react-i18next'

import { Button, ButtonSize, ButtonVariant } from '@/atoms/button'
import { Box, Flex } from '@/atoms/layout'
import { UploadedFile } from '@/atoms/uploaded-file'
import { Space } from '@/styles'

import { DropzoneFile } from '../dropzone'

interface Props {
  acceptedFiles: DropzoneFile[]
  downloadFile: (index: number) => void
  removeFile: (index: number) => void
}

const ActionButtons: FunctionComponent<Props> = ({ acceptedFiles, downloadFile, removeFile }) => {
  const { t } = useTranslation()

  return (
    <>
      {acceptedFiles.map((acceptedFile, index) => (
        <Flex key={index} justifyContent="space-between" alignItems="center" mt={Space.S12}>
          <Box width="75%">
            <UploadedFile filename={acceptedFile.fileName} size={acceptedFile.size} download={() => downloadFile(index)} />
          </Box>
          <Flex width="25%" pl={Space.S12} alignItems="center" justifyContent="flex-end">
            <Button onClick={() => removeFile(index)} variant={ButtonVariant.FLAT_ERROR} size={ButtonSize.SMALL}>
              {t('global.remove_file_btn')}
            </Button>
          </Flex>
        </Flex>
      ))}
    </>
  )
}

export default ActionButtons
